export default "__VITE_ASSET__75881361__"